import React from "react";

const Aboutus = () => {
  return (
    <div className="container-xxl py-5">
      <div className="container py-5 px-lg-5">
        <div className="row g-5 align-items-center">
          {/* Title */}
          <div
            className="col-12 text-center wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <h1 className="mb-5">Our Clients</h1>
          </div>

          {/* Logo Grid */}
          <div className="row text-center justify-content-center g-4">
            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture3.jpg"
                className="img-fluid client-logo"
                alt="Ayana"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture4.jpg"
                className="img-fluid client-logo"
                alt="Digicert"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture5.jpg"
                className="img-fluid client-logo"
                alt="LogixHealth"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture7.jpg"
                className="img-fluid client-logo"
                alt="TEG"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture8.jpg"
                className="img-fluid client-logo"
                alt="PowerSchool"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture9.jpg"
                className="img-fluid client-logo"
                alt="GDT"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture10.jpg"
                className="img-fluid client-logo"
                alt="Novozymes"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture11.jpg"
                className="img-fluid client-logo"
                alt="Neovia"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture12.jpg"
                className="img-fluid client-logo"
                alt="Protiviti"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture13.jpg"
                className="img-fluid client-logo"
                alt="Renesas"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture14.jpg"
                className="img-fluid client-logo"
                alt="7-Eleven"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture15.jpg"
                className="img-fluid client-logo"
                alt="Lavaiva Solutions"
              />
            </div>

            <div className="col-6 col-md-4 col-lg-3">
              <img
                src="/img/Picture17.jpg"
                className="img-fluid client-logo"
                alt="AD Constructions"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
